;(function($) {
    $.widget('ca.caGridScroll', {
        options: {
            animateTime: 400,
            holdTime: 400,
            scrollStep: 104,
            loop: false,
            scrollWrapper: null,
            timeOut: null
        },

        _create : function() {
            var self = this;
            var grid = this.element;
            
            this.options.scrollWrapper = grid.find('#fixWidth');
            
            grid.find('.hl_button, .hr_button').on('mousedown', function() {
                self.options.loop = true;
                self.scrollAnimation($(this), $(this).is('.hr_button'));
            });
            
            grid.find('.hl_button, .hr_button').on('mouseup mouseout', function() {
                self.options.loop = false;
                clearTimeout(self.options.timeOut);
            });
            
            // resize on change orientation
            $(window).bind('orientationchange', function() {
                $(window).resize();
            });
        },
        
        scrollAnimation: function(element, scrollToLeft) {
            var step = scrollToLeft ? '+=' + this.options.scrollStep : '-=' + this.options.scrollStep;
            if (this.options.loop == true) {
                this.options.scrollWrapper.scrollTo(step + 'px', this.options.animateTime);
                
                var self = this;
                this.options.timeOut = setTimeout(function() { 
                    self.scrollAnimation(element, scrollToLeft); 
                }, this.options.holdTime);
            }
            
            return false;
        },
        
        updateButtons: function() {
            var grid = this.element;
            
            if (this.hasScrollBar()) {
                grid.find('.hl_button span, .hr_button span').show();
                grid.find('.hl_button, .hr_button').removeClass('nobg');
            } else {
                grid.find('.hl_button span, .hr_button span').hide();
                grid.find('.hl_button, .hr_button').addClass('nobg');
            }
        }, 
        
        hasScrollBar: function() {
            return this.element.find('#fixWidth table#content').innerWidth() > this.element.find('#fixWidth').innerWidth();
        }
    });
})(jQuery);